<div infiniteScroll [infiniteScrollDistance]="3" [infiniteScrollThrottle]="50"
  [infiniteScrollDisabled]="isMaxProducts || isLastPage || isEmpty"
  (scrolled)="scrollPage(model?.pagination?.currentPage + 1)">
  @for (product of model?.products; track product) {
    <app-uig-product-list-item [product]="product" class="cx-product-search-list">
    </app-uig-product-list-item>
  }
  <div class="product-scroll__container" [ngClass]="
      !isLastPage && model?.pagination?.currentPage > 0
        ? 'cx-double-btn-container'
        : 'cx-single-btn-container'
    ">
    @if ((isMaxProducts || isLastPage) && model?.pagination?.currentPage > 0) {
      <div (click)="scrollToTop()"
        class="btn btn-secondary btn-block">
        {{ "productList.backToTopBtn" | cxTranslate }}
      </div>
    }
    @if (isMaxProducts && !isLastPage) {
      <div (click)="loadNextPage(model?.pagination?.currentPage + 1)"
        class="btn btn-block btn-action align-btn">
        {{ "productList.showMoreBtn" | cxTranslate }}
      </div>
    }
  </div>
  @if (appendProducts) {
    <div class="cx-spinner">
      <cx-spinner></cx-spinner>
    </div>
  }
</div>
